import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from "@material-ui/core/styles/index";
import PropTypes from 'prop-types';
import {Logo} from '../shared/constants';
import {LoadingStyle} from "./style";
import {AppStyle} from '../../app/style';
import combineStyles from "../../providers/StylesUtil";

class Loading extends React.Component {
    state = {
        completed: 0,
    };

    componentDidMount() {
        this.timer = setInterval(this.progress, 20);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    progress = () => {
        const {completed} = this.state;
        this.setState({completed: completed >= 100 ? 0 : completed + 1});
    };

    render() {
        const {classes} = this.props;
        return (<React.Fragment>
            <main>
                <div className={classes.progressUnit}>
                    <div className={classes.progressContent}>
                        <Logo classes={classes}/>
                        <CircularProgress size={100} variant="determinate"
                                          value={this.state.completed}
                                          className={classes.pageProgress}/>
                    </div>
                </div>
            </main>
        </React.Fragment>);
    };

}

Loading.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(combineStyles(LoadingStyle, AppStyle))(Loading);
